import React from 'react';
import {useTypedSelector} from '@common/hooks/useTypedSelector';
import MainContacts from '@components/MainContacts';
import DOMPurify from 'isomorphic-dompurify';
import Text from '@common/components/common/Text';


export const PersonalInformation = () => {
  const {personalInformation} = useTypedSelector(state => state.app);

  return (
    <>
      <section className="inner-title">
        <div className="container">
          <h1 className="inner-title__text">
            <Text text={personalInformation?.title}/>
          </h1>
        </div>
      </section>

      <section className="inner-grid inner-grid--no-padding">
        <div className="container">
          <div className="inner-grid__content">
            <h2 className="inner-simple-title">
              <Text text={personalInformation?.agreement?.title}/>
            </h2>

            <div className="inner-simple-text inner-simple-text--mobile-margin-top-big">
              <p
                dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(personalInformation?.agreement?.description ?? '')}}/>
            </div>

            <div className="inner-simple-box inner-simple-box--bg-white">
              <div className="inner-simple-text inner-simple-text--mobile-margin-big">
                {personalInformation?.conditions?.map((t, index) => (
                  <p key={`paragraph_${index}`} dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(t ?? '')}}/>
                ))}
              </div>
            </div>
          </div>
        </div>

        <MainContacts/>
      </section>
    </>
  )
}

